import * as React from "react"
import type { IconProps } from "../types"

const Notification = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          d="M16.0006 18C15.3273 19.7659 13.7897 21 12.0006 21C10.2114 21 8.67383 19.7659 8.00056 18M5.14274 18H18.8584C19.4632 18 19.9295 17.4673 19.8496 16.8678L18.7935 8.94737C18.3396 5.54271 15.4354 3 12.0006 3C8.56577 3 5.66153 5.5427 5.20758 8.94736L4.15152 16.8678C4.07158 17.4673 4.53795 18 5.14274 18Z"
          stroke={color}
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </svg>
    )
  }
)
Notification.displayName = "Notification"

export default Notification
